import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/index.css'
import App from './App'

// When the active SW changes (new version deployed), reload so the page runs
// the latest assets. The guard prevents a reload loop on first claim.
if ('serviceWorker' in navigator) {
  let refreshing = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true
      window.location.reload()
    }
  })

  // Force an update check every 60 s and whenever the tab becomes visible again,
  // so long-running SPA sessions detect new deploys without a manual page reload.
  navigator.serviceWorker.ready.then(reg => {
    const check = () => reg.update().catch(() => {})
    setInterval(check, 60_000)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') check()
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
